import { UserLocale } from './types'

export const DefaultLocale: UserLocale = 'fi'
export const SupportedLocales: UserLocale[] = ['fi', 'en']
